import { render, staticRenderFns } from "./HrSalaryCalcCompensate.vue?vue&type=template&id=6f8f67b6&scoped=true&"
import script from "./HrSalaryCalcCompensate.vue?vue&type=script&lang=js&"
export * from "./HrSalaryCalcCompensate.vue?vue&type=script&lang=js&"
import style0 from "./HrSalaryCalcCompensate.vue?vue&type=style&index=0&id=6f8f67b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8f67b6",
  null
  
)

export default component.exports